// extracted by css-extract-rspack-plugin
export default {"plusIcon":"_3678fef1","createNftButton":"_24d3bcae","important":"_46d5646","applyBody":"_134d424"};